/* =========================================================================
   Rogers — Página de Produto (rgh-pdp.js)
   Vídeo do herói (modelo adidas): src direto + autoplay + preload=auto, mostra
   o 1º frame do próprio vídeo e toca em seguida. O JS só: (1) adapta o quadro
   ao aspecto REAL do vídeo, (2) pausa quando sai da tela e retoma ao voltar
   (economia de recurso), (3) botão de som. Respeita prefers-reduced-motion.
   ========================================================================= */
(function () {
  var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function initVideoCell(cell) {
    if (cell.__rghInit) return;
    cell.__rghInit = true;
    var v = cell.querySelector('video.rgh-pdp-video');
    if (!v) return;

    // (1) Ajusta o quadro ao aspecto REAL do vídeo (mostra inteiro, sem corte nem barras)
    function applyAspect() {
      if (v.videoWidth && v.videoHeight) {
        var wrap = cell.querySelector('.rgh-pdp-video-wrap');
        if (!wrap) return;
        // A celula pode ser mais ALTA que larga, nunca mais larga. A grade usa colunas
        // `1fr`, que cedem ao conteudo: uma celula deitada pede largura extra, a coluna
        // estica e arrasta todas as fotos junto — medido, 436px viravam 581px. Video em pe
        // pede menos largura e nao empurra nada, por isso so o video deitado quebrava.
        var ar = v.videoWidth / v.videoHeight;
        if (ar > 1) ar = 1;
        wrap.style.aspectRatio = String(ar);
        cell.classList.toggle('rgh-video-deitado', v.videoWidth > v.videoHeight);
      }
    }
    if (v.readyState >= 1) applyAspect();
    else v.addEventListener('loadedmetadata', applyAspect, { once: true });

    // prefers-reduced-motion: não toca sozinho
    if (reduceMotion) { v.removeAttribute('autoplay'); v.pause(); }

    function play() { if (reduceMotion) return; var p = v.play(); if (p && p.catch) p.catch(function () {}); }

    // (2) Pausa fora da tela, retoma ao voltar (o autoplay já dá o play inicial)
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) { if (e.isIntersecting) play(); else v.pause(); });
      }, { threshold: 0.25 });
      io.observe(v);
    }

    // (3) Som: começa MUDO (exigência do autoplay). Clicar no VÍDEO ou no botão de som libera/corta o áudio.
    var btn = cell.querySelector('[data-rgh-sound]');
    function toggleMute() {
      v.muted = !v.muted;
      cell.classList.toggle('is-unmuted', !v.muted);
      if (btn) btn.setAttribute('aria-label', v.muted ? 'Ativar som' : 'Desativar som');
      if (!v.muted) { var p = v.play(); if (p && p.catch) p.catch(function () {}); }
    }
    if (btn) btn.addEventListener('click', function (e) { e.stopPropagation(); toggleMute(); });
    // clicar no próprio vídeo também ativa/desativa o som (padrão do site: mudo no autoplay, som no clique)
    v.style.cursor = 'pointer';
    v.addEventListener('click', toggleMute);
  }

  /* ---- Barra de compra fixa no mobile ---- */
  function initStickyAtc() {
    var sticky = document.querySelector('.rgh-sticky-atc');
    if (!sticky || sticky.__rghInit) return;
    sticky.__rghInit = true;
    var mainBuy = document.querySelector('.product-form__submit');
    var stickyBtn = sticky.querySelector('[data-rgh-sticky-buy]');
    if (!mainBuy || !stickyBtn) return;

    // clicar na barra dispara o MESMO add-to-cart (com validação de tamanho e cart drawer do tema)
    stickyBtn.addEventListener('click', function () { if (!mainBuy.disabled) mainBuy.click(); });

    // espelha texto e estado (disabled) do botão real — mantém sincronizado na troca de tamanho
    function mirror() {
      stickyBtn.disabled = mainBuy.disabled || mainBuy.getAttribute('aria-disabled') === 'true';
      var span = mainBuy.querySelector('span');
      var label = (span ? span.textContent : mainBuy.textContent).replace(/\s+/g, ' ').trim();
      if (label) stickyBtn.textContent = label;
    }
    mirror();
    new MutationObserver(mirror).observe(mainBuy, { attributes: true, childList: true, subtree: true, attributeFilter: ['disabled', 'aria-disabled'] });

    // mostra a barra quando o botão principal está fora da tela
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          var show = !e.isIntersecting;
          sticky.classList.toggle('is-visible', show);
          sticky.setAttribute('aria-hidden', show ? 'false' : 'true');
        });
      }, { threshold: 0 });
      io.observe(mainBuy);
    }
  }

  /* ---- Modal de tamanho esgotado: similares + avise-me ---- */
  function initSizeModal() {
    var modal = document.getElementById('RghSizeModal');
    if (!modal || modal.__rghInit) return;
    modal.__rghInit = true;
    // move o modal p/ o <body> — evita que o transform de um ancestral (animação do tema)
    // "prenda" o position:fixed dentro da coluna. Assim o modal centraliza na TELA.
    if (modal.parentElement !== document.body) document.body.appendChild(modal);
    var mainBuy = document.querySelector('.product-form__submit');
    var sizeOut = modal.querySelector('[data-rgh-modal-size]');
    var sizeField = modal.querySelector('[data-rgh-nform-size]');
    var bodyField = modal.querySelector('[data-rgh-nform-body]');
    var simSection = modal.querySelector('.rgh-modal__sim');
    var cards = [].slice.call(modal.querySelectorAll('.rgh-sim-card'));
    var empty = modal.querySelector('[data-rgh-sim-empty]');
    var productName = modal.getAttribute('data-product') || '';
    // conjunto de tamanhos esgotados deste produto (renderizado no servidor): "|35|36|41|"
    var soldSet = modal.getAttribute('data-rgh-soldout') || '';
    // dados p/ RANQUEAR os similares por relevância real
    var pid = modal.getAttribute('data-product-id') || '';
    var ourType = (modal.getAttribute('data-type') || '').toLowerCase();
    var ourVendor = (modal.getAttribute('data-vendor') || '').toLowerCase();
    var ourPrice = parseInt(modal.getAttribute('data-price') || '0', 10) || 0;
    var simCollection = modal.getAttribute('data-sim-collection') || '';
    var currentSize = '';
    function genderOf(s) {
      s = (s || '').toLowerCase();
      if (/infantil|kids|juvenil|toddler|beb[eê]|crian/.test(s)) return 'infantil';
      if (/femin/.test(s)) return 'feminino';
      if (/mascul/.test(s)) return 'masculino';
      if (/uniss?ex/.test(s)) return 'unissex';
      return '';
    }
    var ourGender = genderOf(productName);
    function fmtBRL(cents) {
      var v = (Math.round(cents) / 100).toFixed(2).split('.');
      return 'R$ ' + v[0].replace(/\B(?=(\d{3})+(?!\d))/g, '.') + ',' + v[1];
    }
    function esc(s) { return (s || '').replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;'); }

    // ===== carrossel de similares (navegado por setas, sem scroll livre) =====
    var track = modal.querySelector('[data-rgh-track]');
    var viewport = modal.querySelector('[data-rgh-viewport]');
    var prevBtn = modal.querySelector('[data-rgh-prev]');
    var nextBtn = modal.querySelector('[data-rgh-next]');
    var pos = 0, opener = null;
    function visibleCards() { return cards.filter(function (c) { return !c.hidden; }); }
    function cardStep() { var vis = visibleCards(); if (!vis.length) return 1; return vis[0].getBoundingClientRect().width + 14; }
    function carouselUpdate() {
      if (!track) return;
      var vis = visibleCards(), step = cardStep();
      var per = Math.max(1, Math.round((viewport ? viewport.clientWidth : step) / step));
      pos = Math.max(0, Math.min(pos, Math.max(0, vis.length - per)));
      track.style.transform = 'translateX(-' + (pos * step) + 'px)';
      var hide = vis.length <= per;
      if (prevBtn) { prevBtn.disabled = pos <= 0; prevBtn.style.display = hide ? 'none' : ''; }
      if (nextBtn) { nextBtn.disabled = pos >= vis.length - per; nextBtn.style.display = hide ? 'none' : ''; }
    }
    function carouselReset() { pos = 0; carouselUpdate(); }
    if (prevBtn) prevBtn.addEventListener('click', function () { pos = Math.max(0, pos - 1); carouselUpdate(); });
    if (nextBtn) nextBtn.addEventListener('click', function () { pos = pos + 1; carouselUpdate(); });
    var carouselRT; window.addEventListener('resize', function () { clearTimeout(carouselRT); carouselRT = setTimeout(carouselUpdate, 150); });

    // ===== similares REALMENTE similares: pool servidor (mesmo tipo) + API related do Shopify, ranqueado =====
    var relatedByHandle = {}, relatedFetched = false, brandFetched = false;
    var relatedDone = false, brandDone = false, poolReady = false, revealTimer = null;
    function reveal() {
      poolReady = true; clearTimeout(revealTimer);
      if (simSection) simSection.classList.remove('is-loading');
      renderPool(currentSize);
    }
    function checkReveal() {
      if (relatedDone && brandDone) { poolReady = true; if (!modal.hidden && modal.classList.contains('is-open')) reveal(); }
    }
    function apiCard(pr, apirel) {
      var img = pr.featured_image || (pr.images && pr.images[0]) || '';
      if (img) img += (img.indexOf('?') > -1 ? '&' : '?') + 'width=320';
      var sizes = '|';
      (pr.variants || []).forEach(function (v) { if (v.available) sizes += ('' + v.option1).trim() + '|'; });
      var hasOff = pr.compare_at_price && pr.compare_at_price > pr.price;
      var off = hasOff ? '<span class="rgh-sim-card__off">-' + Math.round((pr.compare_at_price - pr.price) * 100 / pr.compare_at_price) + '%</span>' : '';
      var priceHtml = (hasOff ? '<s>' + fmtBRL(pr.compare_at_price) + '</s> ' : '') + '<strong>' + fmtBRL(pr.price) + '</strong>';
      var a = document.createElement('a');
      a.className = 'rgh-sim-card';
      a.href = pr.url;
      a.setAttribute('data-sizes', sizes);
      a.setAttribute('data-handle', pr.handle || '');
      a.setAttribute('data-vendor', (pr.vendor || '').toLowerCase());
      a.setAttribute('data-price', pr.price || 0);
      a.setAttribute('data-related', '0');
      a.setAttribute('data-apirel', apirel == null ? '1' : apirel);
      a.hidden = true;
      a.innerHTML = '<div class="rgh-sim-card__imgwrap">' + off +
        '<img class="rgh-sim-card__img" src="' + img + '" alt="' + esc(pr.title) + '" loading="lazy" width="320" height="320"></div>' +
        '<div class="rgh-sim-card__brand">' + esc(pr.vendor) + '</div>' +
        '<div class="rgh-sim-card__name">' + esc(pr.title) + '</div>' +
        '<div class="rgh-sim-card__price">' + priceHtml + '</div>';
      return a;
    }
    function mergeApi() {
      if (!track) return;
      Object.keys(relatedByHandle).forEach(function (h) {
        var ex = track.querySelector('.rgh-sim-card[data-handle="' + h + '"]');
        if (ex) { ex.setAttribute('data-apirel', '1'); return; }  // já existe no pool → só marca como relacionado
        var card = apiCard(relatedByHandle[h]);
        track.appendChild(card);
        cards.push(card);
      });
    }
    function fetchRelated() {
      if (relatedFetched) return;
      relatedFetched = true;
      if (!pid) { relatedDone = true; checkReveal(); return; }
      fetch('/recommendations/products.json?product_id=' + encodeURIComponent(pid) + '&limit=10&intent=related', { headers: { 'Accept': 'application/json' } })
        .then(function (r) { return r.ok ? r.json() : null; })
        .then(function (d) {
          if (d && d.products) {
            d.products.forEach(function (pr) {
              if ((pr.type || '').toLowerCase() !== ourType) return;      // só MESMO tipo (tira mochila/camiseta/etc.)
              if (('' + pr.id) === ('' + pid)) return;
              if (pr.handle) relatedByHandle[pr.handle] = pr;
            });
            mergeApi();
          }
          relatedDone = true; checkReveal();
        })
        .catch(function () { relatedDone = true; checkReveal(); });
    }
    // busca produtos da MESMA MARCA (na coleção do tipo) e adiciona ao pool — garante cobertura da marca,
    // que a API "related" do Shopify não garante. O ranking (+400 marca) e o filtro de tamanho fazem o resto.
    function fetchBrand() {
      if (brandFetched) return;
      brandFetched = true;
      if (!simCollection || !ourVendor) { brandDone = true; checkReveal(); return; }
      // busca as páginas EM PARALELO (rápido) e só então injeta os candidatos da marca de uma vez
      var pages = [1, 2, 3, 4];
      Promise.all(pages.map(function (p) {
        return fetch('/collections/' + encodeURIComponent(simCollection) + '/products.json?limit=250&page=' + p, { headers: { 'Accept': 'application/json' } })
          .then(function (r) { return r.ok ? r.json() : null; }).catch(function () { return null; });
      })).then(function (results) {
        var added = 0;
        results.forEach(function (d) {
          if (!d || !d.products || !track) return;
          d.products.forEach(function (pr) {
            if (added >= 40) return;
            if ((pr.vendor || '').toLowerCase() !== ourVendor) return;      // SÓ a mesma marca
            var pt = (pr.product_type || pr.type || '').toLowerCase();
            if (ourType && pt && pt !== ourType) return;                    // mesmo tipo
            if (('' + pr.id) === ('' + pid)) return;
            if (!pr.handle || track.querySelector('.rgh-sim-card[data-handle="' + pr.handle + '"]')) return; // dedupe
            var v0 = (pr.variants && pr.variants[0]) || {};
            var img = (pr.images && pr.images[0] && (pr.images[0].src || pr.images[0])) || (pr.featured_image || '');
            var card = apiCard({
              id: pr.id, handle: pr.handle, title: pr.title, vendor: pr.vendor, type: pt,
              url: '/products/' + pr.handle, variants: pr.variants, featured_image: img,
              price: Math.round(parseFloat(v0.price || 0) * 100),
              compare_at_price: v0.compare_at_price ? Math.round(parseFloat(v0.compare_at_price) * 100) : null
            }, '0');
            track.appendChild(card);
            cards.push(card);
            added++;
          });
        });
        brandDone = true; checkReveal();
      });
    }
    function scoreCard(c) {
      var s = 0;
      if (c.getAttribute('data-related') === '1') s += 500;                              // mesma cor/modelo (o mais parecido)
      if (ourVendor && (c.getAttribute('data-vendor') || '') === ourVendor) s += 400;    // MESMA MARCA (prioridade alta)
      if (c.getAttribute('data-apirel') === '1') s += 150;                               // Shopify considera relacionado
      var pr = parseInt(c.getAttribute('data-price') || '0', 10) || 0;
      if (ourPrice > 0 && pr > 0) s += Math.max(0, 100 - Math.round(Math.abs(pr - ourPrice) / ourPrice * 100)); // preço próximo
      // GÊNERO: mesmo = +200; unissex combina = +100; conflitante (masc x fem / adulto x infantil) = -5000 → sai da lista
      var nm = c.querySelector('.rgh-sim-card__name');
      var cg = genderOf(nm ? nm.textContent : '');
      if (ourGender && cg) {
        if (cg === ourGender) s += 200;
        else if (cg === 'unissex' || ourGender === 'unissex') s += 100;
        else s -= 5000;
      }
      return s;
    }
    var MAX_SIM = 12;
    function renderPool(size) {
      if (!track) return;
      var matches = [];
      cards.forEach(function (c) {
        var ok = size && (c.getAttribute('data-sizes') || '').indexOf('|' + size + '|') !== -1;
        if (!ok) { c.hidden = true; return; }
        var sc = scoreCard(c);
        if (sc <= -1000) { c.hidden = true; return; }   // gênero conflitante (ex.: feminino p/ produto masculino) — não mostra
        matches.push({ c: c, s: sc });
      });
      matches.sort(function (a, b) { return b.s - a.s; });
      var shown = 0;
      matches.forEach(function (o, i) {
        var vis = i < MAX_SIM;
        o.c.hidden = !vis;
        if (vis) { track.appendChild(o.c); shown++; }   // reordena o DOM por relevância (melhores primeiro)
      });
      if (empty) empty.hidden = shown > 0;
      carouselReset();
    }

    function selectedSize() {
      var checked = document.querySelector('variant-selects input[type="radio"]:checked, .product-form__input input[type="radio"]:checked');
      if (checked) return (checked.value || '').trim();
      var sel = document.querySelector('variant-selects select, .product-form__input select');
      return sel ? sel.value : '';
    }
    // deriva o tamanho a partir do elemento clicado (funciona mesmo se o input estiver disabled)
    function sizeFromClick(target) {
      var input = target.closest('input[type="radio"]');
      if (input) return (input.value || '').trim();
      var label = target.closest('label');
      if (label) {
        if (label.htmlFor) { var i = document.getElementById(label.htmlFor); if (i && i.value) return i.value.trim(); }
        var inner = label.querySelector('input[type="radio"]'); if (inner && inner.value) return inner.value.trim();
        return label.textContent.replace(/variante esgotada.*/i, '').replace(/\s+/g, ' ').trim();
      }
      return '';
    }
    function isSoldSize(size) { return !!size && soldSet.indexOf('|' + size + '|') !== -1; }

    function open(sizeArg, isConfirm) {
      opener = document.activeElement; // p/ devolver o foco ao fechar
      // ao abrir para um NOVO pedido, devolve o formulário e some com a confirmação anterior
      // (sem isto, quem enviasse uma vez ficaria sem formulário no resto da visita)
      if (!isConfirm) {
        var okEl = modal.querySelector('[data-rgh-nform-ok]');
        if (okEl) okEl.hidden = true;
        var formEl = modal.querySelector('.rgh-nform');
        if (formEl) formEl.hidden = false;
      }
      // modo confirmação (reabertura após envio): usa SÓ o tamanho realmente enviado,
      // NUNCA a variante padrão do Dawn — senão mostra número/similares errados no load.
      var size = isConfirm ? (sizeArg || '').trim() : (sizeArg || selectedSize() || '').trim();
      if (sizeOut) sizeOut.textContent = size || '—';
      if (sizeField) sizeField.value = size;
      if (bodyField) bodyField.value = 'Avise-me quando voltar ao estoque: ' + productName + (size ? ' — Tamanho ' + size : '');
      currentSize = size;
      fetchRelated();          // idempotente; se ainda não buscou, busca agora
      fetchBrand();            // idem: garante candidatos da MESMA MARCA no pool
      // evita o "pula-pula": mostra "carregando" e só revela a lista JÁ ordenada quando o pool está pronto
      if (poolReady) {
        if (simSection) simSection.classList.remove('is-loading');
        renderPool(size);
      } else {
        if (simSection) simSection.classList.add('is-loading');
        clearTimeout(revealTimer);
        revealTimer = setTimeout(reveal, 2600);   // teto de espera: revela mesmo se um fetch demorar
      }
      // sem tamanho conhecido na confirmação: esconde os similares (nada de "número —" com a variante padrão)
      if (simSection) simSection.hidden = !!(isConfirm && !size);
      // já aberto? (Dawn pode disparar open() de novo no re-render — NÃO reanimar, senão reinicia do fechado)
      var wasOpen = !modal.hidden && modal.classList.contains('is-open');
      modal.hidden = false;
      document.documentElement.style.overflow = 'hidden';
      modal.classList.remove('is-closing');
      modal.classList.add('is-open');
      carouselReset();                              // reinicia o carrossel coerente com o filtro por tamanho
      // ENTRADA (WAAPI): desktop = fade + leve zoom (modal central); mobile = sobe de baixo (bottom-sheet)
      var box = modal.querySelector('.rgh-modal__box');
      var bd = modal.querySelector('.rgh-modal__backdrop');
      if (box) { box.style.opacity = ''; box.style.transform = ''; }   // resting = CSS (centralizado, sem transform)
      if (bd) bd.style.opacity = '1';
      if (!wasOpen) {                                // anima SÓ na 1ª abertura desta sessão
        var isMobile = window.matchMedia('(max-width:749px)').matches;
        var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion:reduce)').matches;
        if (box && box.animate && !reduce) {
          var frames = isMobile
            ? [{ transform: 'translateY(100%)' }, { transform: 'translateY(0)' }]
            : [{ opacity: 0, transform: 'translateY(14px) scale(.975)' }, { opacity: 1, transform: 'none' }];
          box.animate(frames, { duration: 300, easing: 'cubic-bezier(.16,.84,.44,1)' });
        }
        if (bd && bd.animate && !reduce) bd.animate([{ opacity: 0 }, { opacity: 1 }], { duration: 300, easing: 'ease' });
      }
      var cl = modal.querySelector('.rgh-modal__close'); if (cl) { try { cl.focus(); } catch (e) {} }
    }
    function close() {
      document.documentElement.style.overflow = '';
      var box = modal.querySelector('.rgh-modal__box');
      var bd = modal.querySelector('.rgh-modal__backdrop');
      var isMobile = window.matchMedia('(max-width:749px)').matches;
      var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion:reduce)').matches;
      var finish = function () { modal.hidden = true; modal.classList.remove('is-open', 'is-closing'); if (box) { box.style.transform = ''; box.style.opacity = ''; } if (bd) bd.style.opacity = ''; };
      modal.classList.remove('is-open'); modal.classList.add('is-closing');
      if (box && box.animate && !reduce) {
        var to = isMobile
          ? [{ transform: 'translateY(0)' }, { transform: 'translateY(100%)' }]
          : [{ opacity: 1, transform: 'none' }, { opacity: 0, transform: 'translateY(14px) scale(.975)' }];
        var a = box.animate(to, { duration: 240, easing: 'cubic-bezier(.4,0,.2,1)' });
        if (bd) bd.animate([{ opacity: 1 }, { opacity: 0 }], { duration: 240, easing: 'ease' });
        // fixa o estado final inline p/ não piscar antes do finish() esconder
        if (isMobile) box.style.transform = 'translateY(100%)'; else { box.style.opacity = '0'; box.style.transform = 'translateY(14px) scale(.975)'; }
        if (bd) bd.style.opacity = '0';
        a.onfinish = finish; setTimeout(finish, 280);
      } else { finish(); }
      if (opener && opener.focus) { try { opener.focus(); } catch (e) {} }
    }

    // GATILHO PRINCIPAL (robusto): clique direto num número esgotado abre o modal —
    // funciona mesmo quando o input está disabled (o clique no <label> ainda dispara).
    // Delegado no DOCUMENT (não no seletor) para sobreviver ao re-render do Dawn na troca de variante.
    document.addEventListener('click', function (e) {
      if (!e.target.closest('variant-selects, variant-radios, .product-form__input--pill, fieldset.product-form__input')) return;
      var size = sizeFromClick(e.target);
      if (isSoldSize(size)) { e.preventDefault(); open(size); }
    }, true);

    // GATILHO SECUNDÁRIO: quando um tamanho esgotado é selecionado e o botão vira "disabled"
    // (cobre select/dropdown e mudanças programáticas de variante).
    // IMPORTANTE: só abre se o tamanho SELECIONADO for de fato esgotado — o Dawn desabilita o
    // botão por um instante ao trocar QUALQUER variante (mesmo disponível), o que abriria o modal à toa.
    if (mainBuy) {
      var wasSoldout = mainBuy.disabled || mainBuy.getAttribute('aria-disabled') === 'true';
      new MutationObserver(function () {
        var soldout = mainBuy.disabled || mainBuy.getAttribute('aria-disabled') === 'true';
        if (soldout && !wasSoldout && isSoldSize(selectedSize())) open();
        wasSoldout = soldout;
      }).observe(mainBuy, { attributes: true, attributeFilter: ['disabled', 'aria-disabled'] });
    }

    modal.querySelectorAll('[data-rgh-modal-close]').forEach(function (b) { b.addEventListener('click', close); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !modal.hidden) close(); });

    // pré-carrega os produtos relacionados se ESTE produto tem algum tamanho esgotado
    // (assim, ao abrir o modal, os similares certos já aparecem ranqueados na hora)
    if (soldSet.replace(/\|/g, '')) fetchRelated();   // prefetch leve; o fetchBrand (mais pesado) roda só ao ABRIR o modal

    // guarda o tamanho REALMENTE enviado (o form 'contact' é nativo e recarrega a página;
    // o Shopify não devolve o valor no Liquid, então persistimos p/ reabrir com o número certo)
    var nform = modal.querySelector('.rgh-nform');

    /* ---- Telefone: máscara BR e validação ----
       Celular tem 11 dígitos com o 9 na frente: (11) 91234-5678
       Fixo tem 10:                              (11) 1234-5678
       A máscara decide pelo total digitado, então serve para os dois. */
    var telField = modal.querySelector('[data-rgh-nform-tel]');
    function fmtTel(valor) {
      var d = String(valor || '').replace(/\D/g, '').slice(0, 11);
      if (!d) return '';
      if (d.length <= 2) return '(' + d;
      var ddd = '(' + d.slice(0, 2) + ') ';
      if (d.length <= 6) return ddd + d.slice(2);
      if (d.length <= 10) return ddd + d.slice(2, 6) + '-' + d.slice(6);      // fixo
      return ddd + d.slice(2, 7) + '-' + d.slice(7);                          // celular (9 na frente)
    }
    if (telField) {
      telField.addEventListener('input', function () {
        var antes = this.value, noFim = this.selectionStart === antes.length;
        this.value = fmtTel(antes);
        if (noFim) { try { this.setSelectionRange(this.value.length, this.value.length); } catch (e) {} }
        this.setCustomValidity('');
      });
      telField.addEventListener('blur', function () {
        var d = this.value.replace(/\D/g, '');
        this.setCustomValidity(d.length === 0 || d.length >= 10 ? '' : 'Digite o telefone com DDD (10 ou 11 dígitos).');
      });
    }

    /* ---- Envio do "Avise-me" ----
       Antes usava o form 'contact' do Shopify, que EXIGIA CAPTCHA e RECARREGAVA a página (o cliente
       reclamou dos dois). Agora posta direto no Apps Script, que grava na planilha E manda o e-mail.
       Sem CAPTCHA, sem recarregar: a confirmação aparece ali mesmo. A chave 'k' filtra robô. */
    var PLANILHA_URL = 'https://script.google.com/macros/s/AKfycbybSkDC60SGBk3IMbG7dp0xdduVDVuU-anoldY1A2s0e0kGmifn5d9TSLvaxz-5PYZYOQ/exec';
    var CHAVE_ENVIO = 'rgh-2026-avise-7f3a9c2e';
    var erroBox = modal.querySelector('[data-rgh-nform-erro]');
    var hpField = modal.querySelector('[data-rgh-nform-hp]');   // campo-armadilha anti-robô

    function mostrarErro(msg) { if (erroBox) { erroBox.textContent = msg; erroBox.hidden = false; } }
    function limparErro() { if (erroBox) { erroBox.hidden = true; erroBox.textContent = ''; } }

    /* Cópia para a PLANILHA, em paralelo ao e-mail do Shopify.
       sendBeacon é obrigatório: o form nativo RECARREGA a página e um fetch seria cancelado no meio. */
    function enviarParaPlanilha(dados) {
      if (!PLANILHA_URL) return;
      try {
        var blob = new Blob([JSON.stringify(dados)], { type: 'text/plain;charset=UTF-8' });
        navigator.sendBeacon(PLANILHA_URL, blob);
      } catch (e) {}
    }

    if (nform) nform.addEventListener('submit', function (ev) {
      limparErro();
      var val = function (sel) { var el = modal.querySelector(sel); return el ? String(el.value || '').trim() : ''; };
      var nome = val('#RghNfNome'), email = val('#RghNfEmail');
      var tel = telField ? telField.value.trim() : '';
      var digitos = tel.replace(/\D/g, '');

      // armadilha: se veio preenchido, foi robô — descarta sem avisar
      if (hpField && hpField.value.trim() !== '') { ev.preventDefault(); return; }

      // validações antes de deixar o Shopify recarregar a página
      if (digitos.length < 10) {
        ev.preventDefault();
        mostrarErro('Digite o telefone com DDD (10 ou 11 dígitos).');
        if (telField) telField.focus();
        return;
      }
      if (!/^[^@\s]+@[^@\s]+\.[a-z]{2,}$/i.test(email)) {
        ev.preventDefault(); mostrarErro('Digite um e-mail válido.'); return;
      }

      // 1) planilha (agora, via beacon)   2) e-mail: o form nativo segue seu curso
      enviarParaPlanilha({
        k: CHAVE_ENVIO,
        produto: productName,
        nome: nome,
        email: email,
        telefone: tel,
        tamanho: val('#RghNfSize'),
        url: location.href.split('?')[0]
      });
      // a página vai recarregar: deixa uma marca para mostrar a confirmação quando voltar
      try {
        sessionStorage.setItem('rgh_notify_size', (sizeField && sizeField.value || '').trim());
        sessionStorage.setItem('rgh_notify_sent', '1');
      } catch (e) {}
    });

    /* Depois do envio a página recarrega. Quem decide mostrar a confirmação é a MARCA deixada no
       sessionStorage — não o `contact.posted_successfully?` do Shopify, que testamos e NÃO acende ao
       voltar para a página do produto (o cliente enviava e não via retorno nenhum).
       A marca é consumida na hora, então isso roda uma vez só, nunca em visita normal. */
    (function () {
      var enviou = false, submittedSize = '';
      try {
        enviou = sessionStorage.getItem('rgh_notify_sent') === '1';
        submittedSize = sessionStorage.getItem('rgh_notify_size') || '';
        if (enviou) { sessionStorage.removeItem('rgh_notify_sent'); sessionStorage.removeItem('rgh_notify_size'); }
      } catch (e) {}
      if (!enviou) return;
      var ok = modal.querySelector('[data-rgh-nform-ok]');
      if (ok) ok.hidden = false;         // revela "✓ Prontinho!"
      if (nform) nform.hidden = true;    // esconde o formulário (já foi enviado)
      open(submittedSize, true);         // reabre o modal no tamanho que a pessoa pediu
    })();
  }

  /* ---- Prefetch das outras cores (hover/touch) p/ navegação instantânea ---- */
  function initColorPrefetch() {
    var done = {};
    function prefetch(href) {
      if (!href || done[href]) return; done[href] = 1;
      var l = document.createElement('link'); l.rel = 'prefetch'; l.href = href; document.head.appendChild(l);
    }
    document.querySelectorAll('.rgh-colors [data-rgh-prefetch]').forEach(function (a) {
      var fire = function () { prefetch(a.getAttribute('href')); };
      a.addEventListener('mouseenter', fire, { once: true });
      a.addEventListener('touchstart', fire, { once: true, passive: true });
    });
  }

  /* ---- Gate de tamanho: exige seleção CONSCIENTE antes de comprar ----
     Remove o pré-selecionado do Dawn e bloqueia ATC / Compre já / sticky / kit sem tamanho. */
  function initSizeGate() {
    var picker = document.querySelector('.product-form__input--pill');
    if (!picker || picker.__rghGate) return;
    var radios = picker.querySelectorAll('input[type="radio"]');
    if (radios.length < 2) return;                 // só produtos com tamanho
    picker.__rghGate = true;
    var info = document.querySelector('.product__info-container');

    function hasSize() { return !!picker.querySelector('input[type="radio"]:checked'); }
    function sync() {
      if (info) info.classList.toggle('rgh-needs-size', !hasSize());
      // fonte única de verdade da seleção de tamanho — a urgência e outros componentes escutam
      try { document.dispatchEvent(new CustomEvent('rgh:size', { detail: { has: hasSize() } })); } catch (e) {}
    }

    // desmarca o tamanho pré-selecionado (após o Dawn montar)
    setTimeout(function () {
      var pre = picker.querySelector('input[type="radio"]:checked');
      if (pre) pre.checked = false;
      sync();
    }, 80);

    function msgEl() {
      var m = document.getElementById('RghSizeMsg');
      if (!m) {
        m = document.createElement('div');
        m.id = 'RghSizeMsg'; m.className = 'rgh-size-msg'; m.setAttribute('role', 'alert'); m.hidden = true;
        m.innerHTML = '<svg viewBox="0 0 24 24" width="15" height="15" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><circle cx="12" cy="12" r="10"/><path d="M12 8v4M12 16h.01"/></svg> Selecione um tamanho para continuar';
        picker.insertAdjacentElement('afterend', m);
      }
      return m;
    }
    function warn() {
      var m = msgEl(); m.hidden = false;
      picker.classList.add('rgh-shake'); setTimeout(function () { picker.classList.remove('rgh-shake'); }, 450);
      try { picker.scrollIntoView({ block: 'center', behavior: 'smooth' }); } catch (e) {}
    }
    function clearWarn() { var m = document.getElementById('RghSizeMsg'); if (m) m.hidden = true; }

    picker.addEventListener('change', function () { sync(); clearWarn(); });

    document.querySelectorAll('form[action*="/cart/add"]').forEach(function (form) {
      form.addEventListener('submit', function (e) {
        if (!hasSize()) { e.preventDefault(); e.stopImmediatePropagation(); warn(); }
      }, true);
    });
    document.addEventListener('click', function (e) {
      var pay = e.target.closest('.shopify-payment-button');
      if (pay && !hasSize()) { e.preventDefault(); e.stopImmediatePropagation(); warn(); }
    }, true);

    // exposto p/ o kit consultar/avisar
    window.rghHasSize = hasSize;
    window.rghWarnSize = warn;
    sync();
  }

  /* ---- Roger's Play: vídeo shoppable flutuante (SÓ MOBILE) ---- */
  function initVBubble() {
    var vb = document.querySelector('[data-rgh-vbubble]');
    if (!vb) return;
    if (!window.matchMedia || !window.matchMedia('(max-width:749px)').matches) return; // desktop intacto
    document.body.appendChild(vb); // evita clipping por overflow/transform de ancestrais
    vb.hidden = false;

    // no mobile a bolinha assume: remove o vídeo inline da galeria e recontar o slider
    var inlineCell = document.querySelector('.rgh-pdp-videocell');
    if (inlineCell) {
      var sc = inlineCell.closest('slider-component');
      if (inlineCell.parentNode) inlineCell.parentNode.removeChild(inlineCell);
      try { if (sc && typeof sc.initPages === 'function') sc.initPages(); } catch (e) {}
      try { window.dispatchEvent(new Event('resize')); } catch (e) {}
    }

    var dock = vb.querySelector('[data-vb-dock]');
    var bubble = vb.querySelector('[data-vb-open]');
    var video = vb.querySelector('[data-vb-video]');
    var modal = vb.querySelector('[data-vb-modal]');
    var stage = vb.querySelector('[data-vb-stage]');
    var hold = vb.querySelector('[data-vb-hold]');
    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    function tryPlay(v) { try { var p = v.play(); if (p && p.catch) p.catch(function () {}); } catch (e) {} }

    /* loading ring -> VER nudge */
    dock.classList.add('is-loading');
    var revealed = false;
    function reveal() { if (revealed) return; revealed = true; dock.classList.remove('is-loading'); dock.classList.add('show-nudge', 'is-shown-x'); setTimeout(function () { dock.classList.remove('is-shown-x'); }, 4200); }
    if (video.readyState >= 3) reveal();
    video.addEventListener('canplay', reveal);
    video.addEventListener('playing', reveal);
    setTimeout(reveal, 4000);
    tryPlay(video);

    /* arrastar (pointer events) — NÃO persiste: todo F5/reload volta à posição original (inferior-esquerdo) */
    function applySide(side) { if (side === 'right') { dock.style.right = '14px'; dock.style.left = 'auto'; dock.classList.add('is-right'); } else { dock.style.left = '14px'; dock.style.right = 'auto'; dock.classList.remove('is-right'); } }
    function clampTop(t) { var h = dock.offsetHeight || 86; return Math.max(70, Math.min(window.innerHeight - h - 90, t)); }
    applySide('left');

    /* lixeira: alvo central embaixo, só visível durante o arraste.
       Detecção por RAIO (mais tolerante ao dedo que um retângulo) + ímã que puxa a bolinha. */
    var trash = vb.querySelector('[data-vb-trash]');
    var TRASH_R = 86, MAGNET = .38;
    var trashOn = false, overTrash = false;
    function buzz(p) { try { if (navigator.vibrate) navigator.vibrate(p); } catch (_) {} }
    function trashCenter() { var r = trash.getBoundingClientRect(); return { x: r.left + r.width / 2, y: r.top + r.height / 2 }; }
    /* a barra sticky "Comprar agora" ocupa o rodapé quase sempre — sobe a lixeira acima dela.
       +32 cobre o scale(1.22) do estado armado. O rect da barra já inclui a safe-area. */
    function placeTrash() {
      var gap = null, sb = document.querySelector('.rgh-sticky-atc');
      if (sb) { var r = sb.getBoundingClientRect(); if (r.height && r.top < window.innerHeight - 2) gap = (window.innerHeight - r.top) + 32; }
      trash.style.bottom = gap ? (gap + 'px') : '';
    }
    function showTrash() { if (trashOn) return; trashOn = true; placeTrash(); trash.classList.add('is-visible'); }
    function hideTrash() { if (!trashOn) return; trashOn = false; trash.classList.remove('is-visible', 'is-over'); dock.classList.remove('is-over-trash'); overTrash = false; }
    function resetDockPos() { dock.style.top = ''; dock.style.bottom = ''; dock.classList.remove('is-right'); applySide('left'); }
    function trashAway() {   // anima a bolinha caindo dentro da lixeira e então oculta
      var tc = trashCenter(), w = dock.offsetWidth || 86, h = dock.offsetHeight || 86;
      dock.classList.add('is-trashing');
      dock.style.left = (tc.x - w / 2) + 'px'; dock.style.top = (tc.y - h / 2) + 'px';
      var fin = function () { dock.classList.remove('is-trashing'); doDismiss(); resetDockPos(); };
      if (reduce) fin(); else setTimeout(fin, 270);
    }

    var dragging = false, moved = false, sx = 0, sy = 0, ox = 0, oy = 0;
    function down(e) { if (!e.target.closest('[data-vb-open]')) return; /* só arrasta pela bolinha; libera o × e o nudge */ dragging = true; moved = false; sx = e.clientX; sy = e.clientY; var r = dock.getBoundingClientRect(); ox = r.left; oy = r.top; dock.classList.add('is-dragging'); dock.style.bottom = 'auto'; try { dock.setPointerCapture(e.pointerId); } catch (_) {} }
    function move(e) {
      if (!dragging) return;
      var dx = e.clientX - sx, dy = e.clientY - sy;
      if (Math.abs(dx) + Math.abs(dy) > 6) moved = true;
      var nx = ox + dx, ny = oy + dy;
      if (moved && trash) {
        showTrash();
        var w = dock.offsetWidth || 86, h = dock.offsetHeight || 86;
        var cx = nx + w / 2, cy = ny + h / 2, tc = trashCenter();
        var over = Math.sqrt((cx - tc.x) * (cx - tc.x) + (cy - tc.y) * (cy - tc.y)) < TRASH_R;
        if (over !== overTrash) {                       // entrou/saiu da zona
          overTrash = over;
          trash.classList.toggle('is-over', over);
          dock.classList.toggle('is-over-trash', over);
          if (over) buzz(12);                           // haptic ao acoplar
        }
        if (over) { nx += (tc.x - cx) * MAGNET; ny += (tc.y - cy) * MAGNET; }  // ímã
      }
      dock.style.left = nx + 'px'; dock.style.right = 'auto'; dock.style.top = ny + 'px';
    }
    function up() {
      if (!dragging) return;
      dragging = false; dock.classList.remove('is-dragging');
      if (overTrash) { hideTrash(); buzz([16, 38, 16]); trashAway(); return; }  // soltou na lixeira → fecha
      hideTrash();
      if (!moved) return;
      var r = dock.getBoundingClientRect(); var side = (r.left + r.width / 2) < window.innerWidth / 2 ? 'left' : 'right'; var top = clampTop(r.top); dock.style.top = top + 'px'; applySide(side);
    }
    dock.addEventListener('pointerdown', down);
    dock.addEventListener('pointermove', move);
    dock.addEventListener('pointerup', up);
    dock.addEventListener('pointercancel', up);

    /* dismiss — o × fecha; ao ROLAR de volta ao topo (ver a foto do produto) a bolinha reaparece.
       Não persiste: F5 sempre volta. */
    var dismissed = false, armed = false;
    // esconder por display INLINE — o atributo hidden não funciona aqui porque a regra .rgh-vb{display:block}
    // (autor, no @media mobile) vence o [hidden]{display:none} do navegador.
    /* escudo anti-"clique fantasma": ao esconder a bolinha no pointerup, o navegador ainda dispara
       um click sintético (~300ms) na MESMA coordenada — sem a bolinha ali, ele acertaria o elemento
       de TRÁS (foto/slider), parecendo um duplo-clique. Este overlay engole esse clique e some.
       O CSS traz display:block !important porque o Dawn tem `div:empty{display:none}` e este div é vazio. */
    function shieldGhostClick(ms) {
      var sh = document.createElement('div');
      sh.className = 'rgh-vb__shield'; sh.setAttribute('aria-hidden', 'true');
      var kill = function (ev) { ev.stopPropagation(); ev.preventDefault(); };
      ['click', 'mousedown', 'mouseup', 'pointerdown', 'pointerup', 'touchend'].forEach(function (t) { sh.addEventListener(t, kill, true); });
      document.body.appendChild(sh);
      setTimeout(function () { if (sh.parentNode) sh.parentNode.removeChild(sh); }, ms || 450);
    }
    function doDismiss() { dismissed = true; armed = false; vb.style.display = 'none'; shieldGhostClick(450); }
    function reshowIfReturnedToTop() {
      if (!dismissed) return;
      var y = window.pageYOffset || document.documentElement.scrollTop || 0;
      if (y > 320) { armed = true; }                    // saiu do topo (rolou além da foto)
      else if (y < 70 && armed) { dismissed = false; armed = false; vb.style.display = ''; tryPlay(video); } // voltou ao topo → reaparece
    }
    window.addEventListener('scroll', reshowIfReturnedToTop, { passive: true });
    var xBtn = vb.querySelector('[data-vb-dismiss]');
    // impede o pointerdown de chegar ao dock (senão o arraste captura o ponteiro e "engole" o toque no ×)
    xBtn.addEventListener('pointerdown', function (e) { e.stopPropagation(); });
    // dispara o fechar no pointerup (confiável no toque; não depende do click sintético)
    xBtn.addEventListener('pointerup', function (e) { e.stopPropagation(); e.preventDefault(); doDismiss(); });
    xBtn.addEventListener('click', function (e) { e.stopPropagation(); e.preventDefault(); }); // evita clique sintético reabrir algo

    /* mudo */
    var muteBtn = vb.querySelector('[data-vb-mute]'), iMuted = muteBtn.querySelector('.rgh-vb__i-muted'), iSound = muteBtn.querySelector('.rgh-vb__i-sound');
    function setMuteIcon(muted) { iMuted.hidden = !muted; iSound.hidden = muted; muteBtn.setAttribute('aria-label', muted ? 'Ativar som' : 'Desativar som'); }
    muteBtn.addEventListener('click', function () { video.muted = !video.muted; setMuteIcon(video.muted); if (!video.muted) tryPlay(video); });

    /* abrir / fechar modal */
    var isOpen = false;
    var buyPanel = vb.querySelector('[data-vb-buypanel]'), donePanel = vb.querySelector('[data-vb-done]');
    function resetBuy() { if (donePanel) donePanel.hidden = true; if (buyPanel) buyPanel.hidden = false; }
    function openModal() {
      if (isOpen) return; isOpen = true;
      document.body.appendChild(vb); // reancorar no fim do body: modal cobre botões de app (WhatsApp) no empate de z-index
      if (!reduce) { var r = bubble.getBoundingClientRect(); modal.style.transformOrigin = (r.left + r.width / 2) + 'px ' + (r.top + r.height / 2) + 'px'; }
      modal.hidden = false;
      hold.insertBefore(video, hold.firstChild);
      video.muted = false; setMuteIcon(false); tryPlay(video);
      document.body.classList.add('rgh-vb-lock');
      requestAnimationFrame(function () { modal.classList.add('is-open'); });
    }
    function closeModal() {
      if (!isOpen) return; isOpen = false;
      modal.classList.remove('is-open');
      document.body.classList.remove('rgh-vb-lock');
      var finish = function () { modal.hidden = true; modal.style.opacity = ''; video.muted = true; setMuteIcon(true); bubble.insertBefore(video, bubble.querySelector('.rgh-vb__play')); tryPlay(video); resetBuy(); modal.removeEventListener('transitionend', finish); };
      if (reduce) finish(); else { modal.addEventListener('transitionend', finish); setTimeout(finish, 520); }
    }
    bubble.addEventListener('click', function () { if (moved) { moved = false; return; } openModal(); });
    vb.querySelector('[data-vb-close]').addEventListener('click', closeModal);
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && isOpen) closeModal(); });
    /* swipe-down fecha */
    (function () { var ty = 0, td = 0, act = false; stage.addEventListener('touchstart', function (e) { if (e.target.closest('[data-vb-sheet]') || e.target.closest('.rgh-vb__rail')) { act = false; return; } act = true; ty = e.touches[0].clientY; td = 0; }, { passive: true }); stage.addEventListener('touchmove', function (e) { if (!act) return; td = e.touches[0].clientY - ty; if (td > 0) modal.style.opacity = String(Math.max(.3, 1 - td / 420)); }, { passive: true }); stage.addEventListener('touchend', function () { if (!act) return; if (td > 110) closeModal(); else modal.style.opacity = ''; act = false; }); })();

    /* favoritar (rg_favs) */
    var favBtn = vb.querySelector('[data-vb-fav]'), handle = favBtn.getAttribute('data-handle');
    function getFavs() { try { return JSON.parse(localStorage.getItem('rg_favs') || '[]'); } catch (e) { return []; } }
    function paintFav() { favBtn.classList.toggle('is-on', getFavs().indexOf(handle) !== -1); }
    paintFav();
    favBtn.addEventListener('click', function () { var f = getFavs(), i = f.indexOf(handle); if (i === -1) f.push(handle); else f.splice(i, 1); try { localStorage.setItem('rg_favs', JSON.stringify(f)); } catch (_) {} paintFav(); try { document.dispatchEvent(new CustomEvent('rg_favs:change')); } catch (_) {} });

    /* compartilhar */
    vb.querySelector('[data-vb-share]').addEventListener('click', function () { var full = location.origin + vb.getAttribute('data-url'), title = vb.getAttribute('data-title'); if (navigator.share) navigator.share({ title: title, url: full }).catch(function () {}); else if (navigator.clipboard) navigator.clipboard.writeText(full); });

    /* tamanho + comprar */
    var chips = [].slice.call(vb.querySelectorAll('[data-vb-chip]')), chipsWrap = vb.querySelector('[data-vb-chips]'), selId = null;
    var hint = vb.querySelector('[data-vb-hint]'), cta = vb.querySelector('[data-vb-add]');
    chips.forEach(function (c) { c.addEventListener('click', function () { if (c.getAttribute('data-available') !== 'true') return; chips.forEach(function (x) { x.classList.remove('is-sel'); }); c.classList.add('is-sel'); selId = c.getAttribute('data-id'); if (hint) hint.hidden = true; }); });
    function bumpCart() { fetch('/cart.js').then(function (r) { return r.json(); }).then(function (c) { try { document.dispatchEvent(new CustomEvent('rgh:cart-updated', { detail: c })); } catch (e) {} document.querySelectorAll('.cart-count-bubble span:first-child, [data-cart-count]').forEach(function (el) { el.textContent = c.item_count; }); }).catch(function () {}); }
    cta.addEventListener('click', function () {
      if (!selId) { if (hint) { hint.hidden = false; hint.textContent = 'Escolha um tamanho para continuar'; } chipsWrap.classList.add('rgh-shake'); setTimeout(function () { chipsWrap.classList.remove('rgh-shake'); }, 450); return; }
      cta.classList.add('is-loading'); cta.textContent = 'Adicionando…';
      fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ items: [{ id: Number(selId), quantity: 1 }] }) })
        .then(function (r) { return r.json().then(function (d) { return { ok: r.ok, d: d }; }); })
        .then(function (res) { cta.classList.remove('is-loading'); cta.textContent = 'Adicionar ao carrinho'; if (!res.ok) { if (hint) { hint.hidden = false; hint.textContent = (res.d && res.d.description) || 'Não foi possível adicionar. Tente outro tamanho.'; } return; } if (buyPanel) buyPanel.hidden = true; if (donePanel) donePanel.hidden = false; bumpCart(); })
        .catch(function () { cta.classList.remove('is-loading'); cta.textContent = 'Adicionar ao carrinho'; if (hint) { hint.hidden = false; hint.textContent = 'Falha de conexão. Tente de novo.'; } });
    });
    var contBtn = vb.querySelector('[data-vb-continue]'); if (contBtn) contBtn.addEventListener('click', resetBuy);
  }

  /* ---- Mantém o botão como "Comprar agora" mesmo após o Dawn re-renderizar o form
     (na troca de variante o Dawn substitui o botão; no preview vem "Adicionar ao carrinho"
     do tema publicado — este reforço garante "Comprar agora" no preview E na produção). ---- */
  function initBuyLabel() {
    var scope = document.querySelector('.product__info-container');
    if (!scope) return;
    function apply() {
      var btn = scope.querySelector('.product-form__submit');
      if (!btn) return;
      var span = btn.querySelector('span') || btn;
      var txt = (span.textContent || '').replace(/\s+/g, ' ').trim();
      // estado DISPONÍVEL: garante "Comprar agora" (não toca em "Esgotado"/"Indisponível")
      if (/adicionar ao carrinho|add to cart/i.test(txt) || /^comprar$/i.test(txt)) {
        span.textContent = 'Comprar agora';
      }
    }
    apply();
    try {
      new MutationObserver(function () { apply(); }).observe(scope, { childList: true, subtree: true });
    } catch (e) {}
  }

  function boot() {
    document.querySelectorAll('.rgh-pdp-videocell[data-rgh-video]').forEach(initVideoCell);
    initStickyAtc();
    initSizeModal();
    initColorPrefetch();
    initSizeGate();
    initVBubble();
    initBuyLabel();
  }
  if (document.readyState !== 'loading') boot();
  else document.addEventListener('DOMContentLoaded', boot);
})();

/* ---- Compartilhar (rgh-share): Web Share API nativa (mobile) + copiar link ---- */
(function () {
  function initShare() {
    document.querySelectorAll('rgh-share').forEach(function (el) {
      if (el.__rgh) return; el.__rgh = true;
      var url = el.dataset.url, title = el.dataset.title;
      var nativeBtn = el.querySelector('[data-share-native]');
      if (navigator.share && nativeBtn) {
        el.classList.add('is-native'); nativeBtn.hidden = false;
        nativeBtn.addEventListener('click', function () { navigator.share({ title: title, text: title, url: url }).catch(function () {}); });
      }
      var copyBtn = el.querySelector('[data-share-copy]');
      if (copyBtn) {
        var toast = copyBtn.querySelector('.rgh-share__toast');
        copyBtn.addEventListener('click', function () {
          function done() { if (toast) toast.textContent = 'Link copiado!'; copyBtn.classList.add('is-copied'); setTimeout(function () { copyBtn.classList.remove('is-copied'); }, 1800); }
          function fallback() { var t = document.createElement('textarea'); t.value = url; t.style.position = 'fixed'; t.style.opacity = '0'; document.body.appendChild(t); t.select(); try { document.execCommand('copy'); done(); } catch (e) {} document.body.removeChild(t); }
          if (navigator.clipboard && navigator.clipboard.writeText) { navigator.clipboard.writeText(url).then(done).catch(fallback); } else { fallback(); }
        });
      }
    });
  }
  if (document.readyState !== 'loading') initShare();
  else document.addEventListener('DOMContentLoaded', initShare);
})();
